export default class Country {

  public code = ''
  public name = ''
}
